// extracted by mini-css-extract-plugin
export default {"Registro":"modal_Registro__UWZIS","formulario":"modal_formulario__9Lxal"};